module.exports = __webpack_public_path__ + "img/gekhta.8ce9223f.jpg";